import 'babel-polyfill';

import Vue from 'vue';

import svg_icons from './common/svg_icons.vue';
import google_reviews from './common/google_reviews.vue';

import VueSilentbox from 'vue-silentbox'
Vue.use(VueSilentbox)


// SASS/CSS
import '../../css/sass/public.scss';

// disable the warning about dev/prod
Vue.config.productionTip = false;
// Conditional Styles for the header Phone SVG
document.addEventListener("DOMContentLoaded", function(){
    if(!document.getElementById("homePage")) {
       var element = document.getElementById("phoneSvg");
       if (element) {
       	element.classList.add("style-b");
       }
    }
});

new Vue({
    el: '#app',
    components: {
        'svg-icons': svg_icons,
        'google-reviews': google_reviews,
    },
    data: {
        show: false,
        scroll: false,
        slide: true,
        career1: false,
        career2: false,
        career3: false,
        career4: false,
        career5: false,
        career6: false,
        career7: false,
        career8: false,
        career9: false,
        career10: false,
        faq1: false,
        faq2: false,
        faq3: false,
        faq4: false,
        faq5: false,
        faq6: false,
        faq7: false,
        faq8: false,
        faq9: false,
        faq10: false,
        slideListInsurance: false,
        slideListTrade: false,
        slideListHomeowner: false,
        slideListItems: {},
        openOfferTitle: null,
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.windowResize);
        });
    },
    methods: {
        toggle(e) {
           this.show = !this.show
           e.preventDefault();
        },

        careerToggle1(e) {
           this.career1 = !this.career1
           e.preventDefault();
        },

        careerToggle2(e) {
           this.career2 = !this.career2
           e.preventDefault();
        },
        careerToggle3(e) {
           this.career3 = !this.career3
           e.preventDefault();
        },
        careerToggle4(e) {
           this.career4 = !this.career4
           e.preventDefault();
        },
        careerToggle5(e) {
           this.career5 = !this.career5
           e.preventDefault();
        },
        careerToggle6(e) {
           this.career6 = !this.career6
           e.preventDefault();
        },
        careerToggle7(e) {
           this.career7 = !this.career7
           e.preventDefault();
        },
        careerToggle8(e) {
           this.career8 = !this.career8
           e.preventDefault();
        },
        careerToggle9(e) {
           this.career9 = !this.career9
           e.preventDefault();
        },
        careerToggle10(e) {
           this.career10 = !this.career10
           e.preventDefault();
        },

        faqToggle1(e) {
           this.faq1 = !this.faq1
           e.preventDefault();
        },

        faqToggle2(e) {
           this.faq2 = !this.faq2
           e.preventDefault();
        },
        faqToggle3(e) {
           this.faq3 = !this.faq3
           e.preventDefault();
        },
        faqToggle4(e) {
           this.faq4 = !this.faq4
           e.preventDefault();
        },
        faqToggle5(e) {
           this.faq5 = !this.faq5
           e.preventDefault();
        },
        faqToggle6(e) {
           this.faq6 = !this.faq6
           e.preventDefault();
        },
        faqToggle7(e) {
           this.faq7 = !this.faq7
           e.preventDefault();
        },
        faqToggle8(e) {
           this.faq8 = !this.faq8
           e.preventDefault();
        },
        faqToggle9(e) {
           this.faq9 = !this.faq9
           e.preventDefault();
        },
        faqToggle10(e) {
           this.faq10 = !this.faq10
           e.preventDefault();
        },

        slideListToggle(slideListTitle) {
            const slideListItem = slideListTitle.replace(/ /g, '').toLowerCase();
            this.slideListItemSet(slideListItem);
            this.slideListItems[slideListItem] = !this.slideListItems[slideListItem];
        },
        slideListIsOpen(slideListTitle) {
            const slideListItem = slideListTitle.replace(/ /g, '').toLowerCase();
            this.slideListItemSet(slideListItem);
            return this.slideListItems[slideListItem];
        },
        slideListItemSet(slideListItem) {
            if (!this.slideListItems.hasOwnProperty(slideListItem)) {
                this.$set(this.slideListItems, slideListItem, false);
            }
        },

        toggleOfferTerms(offerTitle) {
            if (this.openOfferTitle === offerTitle) {
                this.openOfferTitle = null;
            } else {
                this.openOfferTitle = offerTitle;
            }
        },

        isOfferTermsOpen(offerTitle) {
            return this.openOfferTitle === offerTitle;
        },

        windowResize() {
            this.show = false;
        },

    },
});


// WEBPACK FOOTER //
// ./html/js/src/public.js